import Vue from "vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from "./App.vue";
import '@/assets/css/reset.css'

import router from "./router";
import store from "@/store/store";

import axios from "axios";
Vue.prototype.$axios = axios;


Vue.config.productionTip = false;

Vue.use(ElementUI);
new Vue({
  router,
  store,
  axios,
  render: (h) => h(App),
}).$mount("#app");
